import { useUser } from '@src/hooks/useUser';
import { useObservableValue } from '@talos/kyoko';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { useOpenOrdersBlotterObs } from './useOpenOrdersBlotterObs';

export function useOpenOrdersCount() {
  const { dataObservable } = useOpenOrdersBlotterObs();
  return useObservableValue(
    () =>
      dataObservable.pipe(
        map(({ data }) => data.length),
        distinctUntilChanged()
      ),
    [dataObservable],
    0
  );
}

export function useCurrentUserOpenOrdersCount() {
  const { dataObservable } = useOpenOrdersBlotterObs();
  const { Name: currentUserName } = useUser();

  return useObservableValue(
    () =>
      dataObservable.pipe(
        map(
          ({ data }) =>
            data.filter(order => order.User === currentUserName || order.RequestUser === currentUserName).length
        ),
        distinctUntilChanged()
      ),
    [dataObservable, currentUserName],
    0
  );
}
